// extracted by mini-css-extract-plugin
module.exports = {"root":"cart-sidebar-wishlist-footer_root__0qsU_","summary":"cart-sidebar-wishlist-footer_summary__Jrxvk","buttons":"cart-sidebar-wishlist-footer_buttons__1LIYe"};